import React from 'react';
import PropTypes from 'prop-types';
import stringUtils from 'angieslist-app-platform/lib/common/utils/stringUtils';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { compose, pure } from 'recompose';
import { analyticsActions, urlCatalog } from 'angieslist-app-platform';
import { stylesColors } from 'angieslist-styles';
import { Row, Col, Button, Input, Modal } from 'angieslist-react-components';
import SlimShowcaseIndexCard from '../../profile/browser/components/SlimShowcaseIndexCard';
import '../../profile/browser/components/showcaseIndex.scss';
import '../../profile/browser/components/ShowcaseGrid.scss';
import showcaseActions from '../common/showcaseActions';
import { defaultProps } from '../../../app/browser/analyticsDefaultProperties';

export class ShowcasePublishConflictModalComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedShowcaseId: get(props.refreshedPublishedShowcase, 'showcaseId'),
    };
  }

  handleSubmit = () => {
    const {
      allPublishedShowcases,
      currentFirstOrderedPublishShowcase,
      saveShowcaseOrder,
      serviceProviderId,
      analyticsLocation,
      refreshedPublishedShowcase,
    } = this.props;
    const newFirstOrderShowcaseId = this.state.selectedShowcaseId;
    const currentShowcaseIdOrder = allPublishedShowcases.map(showcase => showcase.showcaseId);
    const showcaseIdOrderToSave =
      [newFirstOrderShowcaseId,
        ...currentShowcaseIdOrder.filter(item => item !== newFirstOrderShowcaseId),
      ];
    const projectType = newFirstOrderShowcaseId === currentFirstOrderedPublishShowcase.showcaseId ?
      'Original Project' : 'New Project';

    this.props.sendEnhancedTrackEvent({
      name: 'Item Clicked',
      properties: {
        activityLocation: analyticsLocation,
        description: `Save Display Changes - ${projectType}`,
        ...defaultProps,
      },
    });
    saveShowcaseOrder(showcaseIdOrderToSave, serviceProviderId).then(() => {
      window.location.replace(`/app/showcase/${serviceProviderId}/${refreshedPublishedShowcase.showcaseId}/success`);
    });
  }

  handleClose = () => {
    this.props.sendEnhancedTrackEvent({
      name: 'Item Clicked',
      properties: {
        activityLocation: this.props.analyticsLocation,
        description: 'Cancel Publish Showcase Conflict',
        ...defaultProps,
      },
    });
    this.props.onHide();
  }

  render() {
    const {
      currentFirstOrderedPublishShowcase,
      refreshedPublishedShowcase,
      showModal,
      browser,
      headerText,
    } = this.props;

    const isMobile = get(browser, 'lessThan.sm', false);
    const unselectedStyle = {
      borderRadius: '0.15em',
      backgroundColor: stylesColors.white,
    };

    const selectedStyle = {
      borderRadius: '0.15em',
      backgroundColor: stylesColors.backgroundGray,
      boxShadow: '0px 2px 4px rgba(0,0,0,.15)',
    };

    return (
      <div id="showcase-publish-conflict-modal-div">
        <Modal
          show={showModal}
          id="showcase-publish-conflict-modal"
          onHide={this.handleClose}
          style={{ overflowY: 'scroll' }}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {headerText}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row style={{ paddingLeft: '15px', paddingBottom: '15px' }}>
              <Col>
                <Choose>
                  <When condition={isMobile}>
                    Your business is only able to display 1 project on your profile.
                  </When>
                  <Otherwise>
                    Your business is only able to display 1 project on your profile.
                    Learn how to showcase more
                    projects by calling our Sales Team <a id="showcase-publish-conflict-advertiser--phone-link" href={urlCatalog.global.businessCenterPhone()}>({urlCatalog.global.businessCenterPhoneText()})</a>
                  </Otherwise>
                </Choose>
              </Col>
            </Row>
            <Row style={{ paddingLeft: '15px', paddingBottom: '15px' }}>
              <Col>
                <strong>
                  Select the project you would like displayed
                </strong>
              </Col>
            </Row>
            <Row style={{ padding: '0 15px 15px 15px' }}>
              <div id="Edit-Project-Showcase-Component-Container">
                {
                  [
                    refreshedPublishedShowcase,
                    currentFirstOrderedPublishShowcase,
                  ].map((value, index) => (
                    <div
                      className="showcase-publish-conflict-wrapper"
                      key={`showcase-publish-conflict-${value.showcaseId}`}
                      style={{
                        ...(this.state.selectedShowcaseId === value.showcaseId ?
                          selectedStyle : unselectedStyle),
                        marginRight: index === 0 ? 16 : 0,
                      }}
                    >
                      <div style={{ paddingLeft: 15 }}>
                        <Input
                          id={`select-showcase-${value.showcaseId}`}
                          name="Select-Showcase"
                          type="radio"
                          value={value.showcaseId}
                          label={stringUtils.truncate(value.title, 25)}
                          defaultChecked={index === 0}
                          onClick={() => this.setState({ selectedShowcaseId: value.showcaseId })}
                        />
                      </div>
                      <SlimShowcaseIndexCard
                        key={`sortable-showcase-index-card-${value.showcaseId}`}
                        showcase={value}
                        isMobile={isMobile}
                        labelText={value.text}
                      />
                    </div>
                  ))}
              </div>
            </Row>
            <Row>
              <div style={{
                color: stylesColors.darkestGray,
                fontStyle: 'italic',
                textAlign: 'center',
                paddingTop: '15px',
                }}
              >
                Any project not being displayed will have an
                Inactive status on your Published Projects tab.
              </div>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button
              id="showcase-publish-conflict-modal-save"
              bsStyle="primary-office"
              bsSize="small"
              flat
              block={isMobile}
              type="submit"
              onClick={this.handleSubmit}
            >
              Save Changes
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

ShowcasePublishConflictModalComponent.propTypes = {
  showModal: PropTypes.bool.isRequired,
  currentFirstOrderedPublishShowcase: PropTypes.object.isRequired,
  allPublishedShowcases: PropTypes.array.isRequired,
  serviceProviderId: PropTypes.string.isRequired,
  refreshedPublishedShowcase: PropTypes.object.isRequired,
  saveShowcaseOrder: PropTypes.func.isRequired,
  browser: PropTypes.shape({
    lessThan: PropTypes.shape({
      sm: PropTypes.bool,
    }),
  }).isRequired,
  sendEnhancedTrackEvent: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
  headerText: PropTypes.string.isRequired,
  analyticsLocation: PropTypes.string.isRequired,
};

export default hot(module)(compose(
  connect(state => ({
    showcase: state.showcase,
    browser: state.browser,
  }), {
    ...analyticsActions,
    ...showcaseActions,
  }),
  pure,
)(ShowcasePublishConflictModalComponent));



// WEBPACK FOOTER //
// ./src/modules/showcase/browser/ShowcasePublishConflictModal.js